export const isStillInIframe = () => {
  try {
    return window.location.host.includes('editor.wixapps.net')
  } catch (e) {
    return false
  }
}
